export default __webpack_public_path__ + "static/media/hostfully_step17.0f805de3.png";